import { CommunityUsersByGroups, Loader } from 'components';
import { StyledErrorMessage } from 'components/Inputs/styled';
import React, { FC } from 'react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Community, CommunityMembersByGroups, CommunityUser } from 'types';
import { hasCommunityOrGroupAdminPermissions } from 'utils';

import { GridGhostWrapper, StyledSectionTitle } from '../styled';
import { StyledHeaderWrapper, StyledRecipentsContainer } from './styled';

interface EmailModuleRecipientsProps {
  selectedRecipients: string[];
  membersByGroups: CommunityMembersByGroups[];
  users: CommunityUser[];
  membersToGroupsLoading: boolean;
  onChange: (value: string[]) => void;
  handleOnWrapperClick: (e: MouseEvent) => void;
  currentUserId: string;
  community: Community;
  error?: FieldError;
}

const EmailModuleRecipients: FC<EmailModuleRecipientsProps> = ({
  selectedRecipients,
  membersByGroups,
  users,
  membersToGroupsLoading,
  onChange,
  handleOnWrapperClick,
  currentUserId,
  community,
  error,
}) => {
  const { t } = useTranslation();

  return (
    <StyledRecipentsContainer>
      {!hasCommunityOrGroupAdminPermissions(currentUserId, community) && (
        <GridGhostWrapper onClick={(e) => handleOnWrapperClick(e)} />
      )}

      <StyledHeaderWrapper>
        <StyledSectionTitle>{t('email.recipients')}</StyledSectionTitle>
      </StyledHeaderWrapper>
      {!membersToGroupsLoading ? (
        <CommunityUsersByGroups
          value={selectedRecipients}
          membersByGroups={membersByGroups}
          users={users}
          height={'calc(100svh - 220px - 60px)'}
          onChange={onChange}
        />
      ) : (
        <Loader />
      )}
    </StyledRecipentsContainer>
  );
};

export default EmailModuleRecipients;
